import packageJson from '../../package.json';

export const environment = {
  production: true,
  name: 'pre',
  appVersion: packageJson.version,
  serverUrl: '/api',
  reservationServerUrl: '/v2/api',
  defaultLanguage: 'en-GB',
  supportedLanguages: ['es-ES', 'en-GB'],
  URL_BASE: 'https://uat.api.online-retail.net',
  mockAuth: {
    enabled: false, // Ensure real Cognito auth is used in deployed environments
    tokenUrl: 'https://wl-uk-api-test.auth.eu-west-2.amazoncognito.com/oauth2/token',
    clientId: '6otgf4rcjmp2hdogf6ouj3vb7o',
    clientSecret: 'qv1dqooq7ikk3o6ui26s8a4036kv18g0p9of6ni6m0mlh6anhvt',
  },
  signInProviders: [
    {
      id: 'cognito',
      label: 'Sign in',
      issuerUrl: 'https://cognito-idp.eu-west-2.amazonaws.com',
      userPoolId: 'eu-west-2_7FWN3efD8',
      clientId: '11iqc4toa4ia9fh640b5e4lg41',
      redirectUri: 'https://test.sjp.online-retail.net/login',
      scopes: 'openid profile email api/client api/oasis api/refdata api/reservations',
    }
  ],
  sessionTimeoutMinutes: 30,
  sessionModalTimeoutSeconds: 60,
  sessionWarningMinutes: 28,
  cacheDuration: 60 * 60 * 1000, // 1 hour
  maxCacheSize: 50, // Maximum number of items in cache
  maxCacheSizeBytes: 5 * 1024 * 1024, // 5MB in bytes
  termsUrl:
    'https://www.nationalrail.co.uk/travel-information/your-rights-and-obligations-as-a-passenger/',
  railConditionsUrl: 'https://example.com/national-rail-conditions-of-travel',
  privacyPolicyUrl: 'https://www.example.com/privacy-policy',
  enablePostLoginFlow: true,
};

/*import packageJson from '../../package.json';

export const environment = {
  production: true,
  name: 'pre',
  appVersion: packageJson.version,
  serverUrl: '/api',
  reservationServerUrl: '/v2/api',
  defaultLanguage: 'en-GB',
  supportedLanguages: ['es-ES', 'en-GB'],
  URL_BASE: 'https://uat.api.online-retail.net',
  mockAuth: {
    enabled: false, // Ensure real Cognito auth is used in deployed environments
    tokenUrl: '/oauth2/token',
    clientId: '6otgf4rcjmp2hdogf6ouj3vb7o',
    clientSecret: 'qv1dqooq7ikk3o6ui26s8a4036kv18g0p9of6ni6m0mlh6anhvt',
  },
  signInProviders: [
    {
      id: 'cognito',
      label: 'Sign in',
      issuerUrl: 'https://cognito-idp.eu-west-2.amazonaws.com',
      //userPoolId: 'eu-west-2_9RrzXL20K',
      //clientId: '4horpitna5fqbe8fjjr9ar4ld2',
      userPoolId: 'eu-west-2_7FWN3efD8',
      clientId: '11iqc4toa4ia9fh640b5e4lg41',
      redirectUri: 'https://dev.sjp.online-retail.net/login',
      scopes: 'openid profile email api/client api/oasis api/refdata api/reservations',
    }
  ],
  sessionTimeoutMinutes: 30,
  sessionModalTimeoutSeconds: 60,
  sessionWarningMinutes: 28,
  cacheDuration: 60 * 60 * 1000, // 1 hour
  maxCacheSize: 50, // Maximum number of items in cache
  maxCacheSizeBytes: 5 * 1024 * 1024, // 5MB in bytes
  termsUrl:
    'https://www.nationalrail.co.uk/travel-information/your-rights-and-obligations-as-a-passenger/',
  railConditionsUrl: 'https://example.com/national-rail-conditions-of-travel',
  privacyPolicyUrl: 'https://www.example.com/privacy-policy',
  enablePostLoginFlow: true,
};
*/